var CurrencyCode = /*@__PURE__*/(function (CurrencyCode) {
    CurrencyCode["Aed"] = "AED";
    CurrencyCode["Afn"] = "AFN";
    CurrencyCode["All"] = "ALL";
    CurrencyCode["Amd"] = "AMD";
    CurrencyCode["Ang"] = "ANG";
    CurrencyCode["Aoa"] = "AOA";
    CurrencyCode["Ars"] = "ARS";
    CurrencyCode["Aud"] = "AUD";
    CurrencyCode["Awg"] = "AWG";
    CurrencyCode["Azn"] = "AZN";
    CurrencyCode["Bam"] = "BAM";
    CurrencyCode["Bbd"] = "BBD";
    CurrencyCode["Bdt"] = "BDT";
    CurrencyCode["Bgn"] = "BGN";
    CurrencyCode["Bhd"] = "BHD";
    CurrencyCode["Bif"] = "BIF";
    CurrencyCode["Bmd"] = "BMD";
    CurrencyCode["Bnd"] = "BND";
    CurrencyCode["Bob"] = "BOB";
    CurrencyCode["Brl"] = "BRL";
    CurrencyCode["Bsd"] = "BSD";
    CurrencyCode["Btn"] = "BTN";
    CurrencyCode["Bwp"] = "BWP";
    CurrencyCode["Byn"] = "BYN";
    CurrencyCode["Bzd"] = "BZD";
    CurrencyCode["Cad"] = "CAD";
    CurrencyCode["Cdf"] = "CDF";
    CurrencyCode["Chf"] = "CHF";
    CurrencyCode["Clp"] = "CLP";
    CurrencyCode["Cny"] = "CNY";
    CurrencyCode["Cop"] = "COP";
    CurrencyCode["Crc"] = "CRC";
    CurrencyCode["Cup"] = "CUP";
    CurrencyCode["Cve"] = "CVE";
    CurrencyCode["Czk"] = "CZK";
    CurrencyCode["Djf"] = "DJF";
    CurrencyCode["Dkk"] = "DKK";
    CurrencyCode["Dop"] = "DOP";
    CurrencyCode["Dzd"] = "DZD";
    CurrencyCode["Egp"] = "EGP";
    CurrencyCode["Ern"] = "ERN";
    CurrencyCode["Etb"] = "ETB";
    CurrencyCode["Eur"] = "EUR";
    CurrencyCode["Fjd"] = "FJD";
    CurrencyCode["Fkp"] = "FKP";
    CurrencyCode["Gbp"] = "GBP";
    CurrencyCode["Gel"] = "GEL";
    CurrencyCode["Ggp"] = "GGP";
    CurrencyCode["Ghs"] = "GHS";
    CurrencyCode["Gip"] = "GIP";
    CurrencyCode["Gmd"] = "GMD";
    CurrencyCode["Gnf"] = "GNF";
    CurrencyCode["Gtq"] = "GTQ";
    CurrencyCode["Gyd"] = "GYD";
    CurrencyCode["Hkd"] = "HKD";
    CurrencyCode["Hnl"] = "HNL";
    CurrencyCode["Hrk"] = "HRK";
    CurrencyCode["Htg"] = "HTG";
    CurrencyCode["Huf"] = "HUF";
    CurrencyCode["Idr"] = "IDR";
    CurrencyCode["Ils"] = "ILS";
    CurrencyCode["Imp"] = "IMP";
    CurrencyCode["Inr"] = "INR";
    CurrencyCode["Iqd"] = "IQD";
    CurrencyCode["Irr"] = "IRR";
    CurrencyCode["Isk"] = "ISK";
    CurrencyCode["Jep"] = "JEP";
    CurrencyCode["Jmd"] = "JMD";
    CurrencyCode["Jod"] = "JOD";
    CurrencyCode["Jpy"] = "JPY";
    CurrencyCode["Kes"] = "KES";
    CurrencyCode["Kgs"] = "KGS";
    CurrencyCode["Khr"] = "KHR";
    CurrencyCode["Kmf"] = "KMF";
    CurrencyCode["Kpw"] = "KPW";
    CurrencyCode["Krw"] = "KRW";
    CurrencyCode["Kwd"] = "KWD";
    CurrencyCode["Kyd"] = "KYD";
    CurrencyCode["Kzt"] = "KZT";
    CurrencyCode["Lak"] = "LAK";
    CurrencyCode["Lbp"] = "LBP";
    CurrencyCode["Lkr"] = "LKR";
    CurrencyCode["Lrd"] = "LRD";
    CurrencyCode["Lsl"] = "LSL";
    CurrencyCode["Lyd"] = "LYD";
    CurrencyCode["Mad"] = "MAD";
    CurrencyCode["Mdl"] = "MDL";
    CurrencyCode["Mga"] = "MGA";
    CurrencyCode["Mkd"] = "MKD";
    CurrencyCode["Mmk"] = "MMK";
    CurrencyCode["Mnt"] = "MNT";
    CurrencyCode["Mop"] = "MOP";
    CurrencyCode["Mru"] = "MRU";
    CurrencyCode["Mur"] = "MUR";
    CurrencyCode["Mvr"] = "MVR";
    CurrencyCode["Mwk"] = "MWK";
    CurrencyCode["Mxn"] = "MXN";
    CurrencyCode["Myr"] = "MYR";
    CurrencyCode["Mzn"] = "MZN";
    CurrencyCode["Nad"] = "NAD";
    CurrencyCode["Ngn"] = "NGN";
    CurrencyCode["Nio"] = "NIO";
    CurrencyCode["Nok"] = "NOK";
    CurrencyCode["Npr"] = "NPR";
    CurrencyCode["Nzd"] = "NZD";
    CurrencyCode["Omr"] = "OMR";
    CurrencyCode["Pab"] = "PAB";
    CurrencyCode["Pen"] = "PEN";
    CurrencyCode["Pgk"] = "PGK";
    CurrencyCode["Php"] = "PHP";
    CurrencyCode["Pkr"] = "PKR";
    CurrencyCode["Pln"] = "PLN";
    CurrencyCode["Pyg"] = "PYG";
    CurrencyCode["Qar"] = "QAR";
    CurrencyCode["Ron"] = "RON";
    CurrencyCode["Rsd"] = "RSD";
    CurrencyCode["Rub"] = "RUB";
    CurrencyCode["Rwf"] = "RWF";
    CurrencyCode["Sar"] = "SAR";
    CurrencyCode["Sbd"] = "SBD";
    CurrencyCode["Scr"] = "SCR";
    CurrencyCode["Sdg"] = "SDG";
    CurrencyCode["Sek"] = "SEK";
    CurrencyCode["Sgd"] = "SGD";
    CurrencyCode["Shp"] = "SHP";
    CurrencyCode["Sll"] = "SLL";
    CurrencyCode["Sos"] = "SOS";
    CurrencyCode["Spl"] = "SPL";
    CurrencyCode["Srd"] = "SRD";
    CurrencyCode["Stn"] = "STN";
    CurrencyCode["Svc"] = "SVC";
    CurrencyCode["Syp"] = "SYP";
    CurrencyCode["Szl"] = "SZL";
    CurrencyCode["Thb"] = "THB";
    CurrencyCode["Tjs"] = "TJS";
    CurrencyCode["Tmt"] = "TMT";
    CurrencyCode["Tnd"] = "TND";
    CurrencyCode["Top"] = "TOP";
    CurrencyCode["Try"] = "TRY";
    CurrencyCode["Ttd"] = "TTD";
    CurrencyCode["Tvd"] = "TVD";
    CurrencyCode["Twd"] = "TWD";
    CurrencyCode["Tzs"] = "TZS";
    CurrencyCode["Uah"] = "UAH";
    CurrencyCode["Ugx"] = "UGX";
    CurrencyCode["Usd"] = "USD";
    CurrencyCode["Uyu"] = "UYU";
    CurrencyCode["Uzs"] = "UZS";
    CurrencyCode["Vef"] = "VEF";
    CurrencyCode["Vnd"] = "VND";
    CurrencyCode["Vuv"] = "VUV";
    CurrencyCode["Wst"] = "WST";
    CurrencyCode["Xaf"] = "XAF";
    CurrencyCode["Xcd"] = "XCD";
    CurrencyCode["Xdr"] = "XDR";
    CurrencyCode["Xof"] = "XOF";
    CurrencyCode["Xpf"] = "XPF";
    CurrencyCode["Yer"] = "YER";
    CurrencyCode["Zar"] = "ZAR";
    CurrencyCode["Zmw"] = "ZMW";
    CurrencyCode["Zwd"] = "ZWD";
    return CurrencyCode;
})(CurrencyCode || (CurrencyCode = {}));

const THN_DATE_FORMAT = 'Y/MM/DD';
const CURRENT_SCRIPT_ATTR = 'data-thn-current';
const CURRENT_SCRIPT_VAR = '__thn_script_src';
const DEFAULT_PROPERTY_DESCRIPTOR = {
    enumerable: true,
    configurable: true,
};
const MEDIA = {
    1: { id: 1, name: 'desktop' },
    2: { id: 2, name: 'mobile' },
    3: { id: 3, name: 'tablet' },
};

var Device = /*@__PURE__*/(function (Device) {
    Device["Desktop"] = "desktop";
    Device["Mobile"] = "mobile";
    Device["Tablet"] = "tablet";
    return Device;
})(Device || (Device = {}));

var DiscountCodeKind = /*@__PURE__*/(function (DiscountCodeKind) {
    DiscountCodeKind["Default"] = "default";
    DiscountCodeKind["Promocode"] = "default";
    DiscountCodeKind["Rate"] = "rate";
    DiscountCodeKind["Coupon"] = "coupon";
    DiscountCodeKind["Corpo"] = "corpo";
    DiscountCodeKind["Group"] = "group";
    return DiscountCodeKind;
})(DiscountCodeKind || (DiscountCodeKind = {}));
var DiscountCodeAmountKind = /*@__PURE__*/(function (DiscountCodeAmountKind) {
    DiscountCodeAmountKind["Absolute"] = "absolute";
    DiscountCodeAmountKind["Relative"] = "relative";
    return DiscountCodeAmountKind;
})(DiscountCodeAmountKind || (DiscountCodeAmountKind = {}));

var FontType = /*@__PURE__*/(function (FontType) {
    FontType["Google"] = "google";
    FontType["File"] = "file";
    FontType["Regular"] = "regular";
    return FontType;
})(FontType || (FontType = {}));

var ToolActionKind = /*@__PURE__*/(function (ToolActionKind) {
    ToolActionKind["ApplyDiscount"] = "apply-discount";
    ToolActionKind["Dismiss"] = "dismiss";
    ToolActionKind["Hide"] = "hide";
    ToolActionKind["EmptyClick"] = "empty-click";
    ToolActionKind["Fallback"] = "none";
    ToolActionKind["GenericLinkClick"] = "generic-link-click";
    ToolActionKind["LoadScript"] = "load-script";
    ToolActionKind["OpenBookingEngine"] = "open-be";
    ToolActionKind["OpenUri"] = "open-uri";
    ToolActionKind["PredictiveAudience"] = "predictive-audience";
    ToolActionKind["SendForm"] = "send-form";
    ToolActionKind["SendSaveSearch"] = "send-save-search";
    ToolActionKind["SendSiteContact"] = "send-site-contact";
    ToolActionKind["SendSubscribe"] = "send-subscribe";
    ToolActionKind["Show"] = "show";
    return ToolActionKind;
})(ToolActionKind || (ToolActionKind = {}));

var LanguageCode = /*@__PURE__*/(function (LanguageCode) {
    LanguageCode["Abkhazian"] = "ab";
    LanguageCode["Afar"] = "aa";
    LanguageCode["Afrikaans"] = "af";
    LanguageCode["Akan"] = "ak";
    LanguageCode["Albanian"] = "sq";
    LanguageCode["Amharic"] = "am";
    LanguageCode["Arabic"] = "ar";
    LanguageCode["Aragonese"] = "an";
    LanguageCode["Armenian"] = "hy";
    LanguageCode["Assamese"] = "as";
    LanguageCode["Avaric"] = "av";
    LanguageCode["Avestan"] = "ae";
    LanguageCode["Aymara"] = "ay";
    LanguageCode["Azerbaijani"] = "az";
    LanguageCode["Bambara"] = "bm";
    LanguageCode["Bashkir"] = "ba";
    LanguageCode["Basque"] = "eu";
    LanguageCode["Belarusian"] = "be";
    LanguageCode["Bengali"] = "bn";
    LanguageCode["Bihari"] = "bh";
    LanguageCode["Bislama"] = "bi";
    LanguageCode["Bosnian"] = "bs";
    LanguageCode["Breton"] = "br";
    LanguageCode["Bulgarian"] = "bg";
    LanguageCode["Burmese"] = "my";
    LanguageCode["Catalan"] = "ca";
    LanguageCode["Chamorro"] = "ch";
    LanguageCode["Chechen"] = "ce";
    LanguageCode["Chewa"] = "ny";
    LanguageCode["Chinese"] = "zh";
    LanguageCode["ChineseTraditional"] = "zh_TW";
    LanguageCode["Chuvash"] = "cv";
    LanguageCode["Cornish"] = "kw";
    LanguageCode["Corsican"] = "co";
    LanguageCode["Cree"] = "cr";
    LanguageCode["Croatian"] = "hr";
    LanguageCode["Czech"] = "cs";
    LanguageCode["Danish"] = "da";
    LanguageCode["Divehi"] = "dv";
    LanguageCode["Dutch"] = "nl";
    LanguageCode["Dzongkha"] = "dz";
    LanguageCode["English"] = "en";
    LanguageCode["Esperanto"] = "eo";
    LanguageCode["Estonian"] = "et";
    LanguageCode["Ewe"] = "ee";
    LanguageCode["Faroese"] = "fo";
    LanguageCode["Fijian"] = "fj";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["French"] = "fr";
    LanguageCode["Fula"] = "ff";
    LanguageCode["Galician"] = "gl";
    LanguageCode["Georgian"] = "ka";
    LanguageCode["German"] = "de";
    LanguageCode["Greek"] = "el";
    LanguageCode["Greenlandic"] = "gn";
    LanguageCode["Gujarati"] = "gu";
    LanguageCode["Haitian"] = "ht";
    LanguageCode["Hausa"] = "ha";
    LanguageCode["Hebrew"] = "he";
    LanguageCode["Herero"] = "hz";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Hiri"] = "ho";
    LanguageCode["Hungarian"] = "hu";
    LanguageCode["Interlingua"] = "ia";
    LanguageCode["Indonesian"] = "id";
    LanguageCode["Interlingue"] = "ie";
    LanguageCode["Irish"] = "ga";
    LanguageCode["Igbo"] = "ig";
    LanguageCode["Inupiaq"] = "ik";
    LanguageCode["Ido"] = "io";
    LanguageCode["Icelandic"] = "is";
    LanguageCode["Italian"] = "it";
    LanguageCode["Inuktitut"] = "iu";
    LanguageCode["Japanese"] = "ja";
    LanguageCode["Javanese"] = "jv";
    LanguageCode["Kalaallisut"] = "kl";
    LanguageCode["Kannada"] = "kn";
    LanguageCode["Kanuri"] = "kr";
    LanguageCode["Kashmiri"] = "ks";
    LanguageCode["Kazakh"] = "kk";
    LanguageCode["Khmer"] = "km";
    LanguageCode["Kikuyu"] = "ki";
    LanguageCode["Kinyarwanda"] = "rw";
    LanguageCode["Kirghiz"] = "ky";
    LanguageCode["Komi"] = "kv";
    LanguageCode["Kongo"] = "kg";
    LanguageCode["Korean"] = "ko";
    LanguageCode["Kurdish"] = "ku";
    LanguageCode["Kuanyama"] = "kj";
    LanguageCode["Latin"] = "la";
    LanguageCode["Luxembourgish"] = "lb";
    LanguageCode["Ganda"] = "lg";
    LanguageCode["Limburgish"] = "li";
    LanguageCode["Lingala"] = "ln";
    LanguageCode["Lao"] = "lo";
    LanguageCode["Lithuanian"] = "lt";
    LanguageCode["Luba"] = "lu";
    LanguageCode["Latvian"] = "lv";
    LanguageCode["Manx"] = "gv";
    LanguageCode["Macedonian"] = "mk";
    LanguageCode["Malagasy"] = "mg";
    LanguageCode["Malay"] = "ms";
    LanguageCode["Malayalam"] = "ml";
    LanguageCode["Maltese"] = "mt";
    LanguageCode["Maori"] = "mi";
    LanguageCode["Marathi"] = "mr";
    LanguageCode["Marshallese"] = "mh";
    LanguageCode["Mongolian"] = "mn";
    LanguageCode["Nauru"] = "na";
    LanguageCode["Navajo"] = "nv";
    LanguageCode["NorthNdebele"] = "nd";
    LanguageCode["Nepali"] = "ne";
    LanguageCode["Ndonga"] = "ng";
    LanguageCode["NorwegianBokmal"] = "nb";
    LanguageCode["NorwegianNynorsk"] = "nn";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Nuosu"] = "ii";
    LanguageCode["SouthNdebele"] = "nr";
    LanguageCode["Occitan"] = "oc";
    LanguageCode["Ojibwe"] = "oj";
    LanguageCode["Old"] = "cu";
    LanguageCode["Oromo"] = "om";
    LanguageCode["Oriya"] = "or";
    LanguageCode["Ossetian"] = "os";
    LanguageCode["Panjabi"] = "pa";
    LanguageCode["Pali"] = "pi";
    LanguageCode["Persian"] = "fa";
    LanguageCode["Polish"] = "pl";
    LanguageCode["Pashto"] = "ps";
    LanguageCode["Portuguese"] = "pt";
    LanguageCode["Quechua"] = "qu";
    LanguageCode["Romansh"] = "rm";
    LanguageCode["Rundi"] = "rn";
    LanguageCode["Romanian"] = "ro";
    LanguageCode["Russian"] = "ru";
    LanguageCode["Sanskrit"] = "sa";
    LanguageCode["Sardinian"] = "sc";
    LanguageCode["Sindhi"] = "sd";
    LanguageCode["Northern"] = "se";
    LanguageCode["Samoan"] = "sm";
    LanguageCode["Sango"] = "sg";
    LanguageCode["Serbian"] = "sr";
    LanguageCode["Scottish"] = "gd";
    LanguageCode["Shona"] = "sn";
    LanguageCode["Sinhala"] = "si";
    LanguageCode["Slovak"] = "sk";
    LanguageCode["Slovene"] = "sl";
    LanguageCode["Somali"] = "so";
    LanguageCode["Sotho"] = "st";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Sundanese"] = "su";
    LanguageCode["Swahili"] = "sw";
    LanguageCode["Swati"] = "ss";
    LanguageCode["Swedish"] = "sv";
    LanguageCode["Tamil"] = "ta";
    LanguageCode["Telugu"] = "te";
    LanguageCode["Tajik"] = "tg";
    LanguageCode["Thai"] = "th";
    LanguageCode["Tigrinya"] = "ti";
    LanguageCode["Tibetan"] = "bo";
    LanguageCode["Turkmen"] = "tk";
    LanguageCode["Tagalog"] = "tl";
    LanguageCode["Tswana"] = "tn";
    LanguageCode["Tonga"] = "to";
    LanguageCode["Turkish"] = "tr";
    LanguageCode["Tsonga"] = "ts";
    LanguageCode["Tatar"] = "tt";
    LanguageCode["Twi"] = "tw";
    LanguageCode["Tahitian"] = "ty";
    LanguageCode["Uighur"] = "ug";
    LanguageCode["Ukrainian"] = "uk";
    LanguageCode["Urdu"] = "ur";
    LanguageCode["Uzbek"] = "uz";
    LanguageCode["Venda"] = "ve";
    LanguageCode["Vietnamese"] = "vi";
    LanguageCode["Volapuk"] = "vo";
    LanguageCode["Walloon"] = "wa";
    LanguageCode["Welsh"] = "cy";
    LanguageCode["Wolof"] = "wo";
    LanguageCode["Western"] = "fy";
    LanguageCode["Xhosa"] = "xh";
    LanguageCode["Yiddish"] = "yi";
    LanguageCode["Yoruba"] = "yo";
    LanguageCode["Zhuang"] = "za";
    LanguageCode["Zulu"] = "zu";
    return LanguageCode;
})(LanguageCode || (LanguageCode = {}));
var RightToLeftLanguageCode = /*@__PURE__*/(function (RightToLeftLanguageCode) {
    RightToLeftLanguageCode["Arabic"] = "ar";
    RightToLeftLanguageCode["Hebrew"] = "he";
    RightToLeftLanguageCode["Persian"] = "fa";
    RightToLeftLanguageCode["Urdu"] = "ur";
    return RightToLeftLanguageCode;
})(RightToLeftLanguageCode || (RightToLeftLanguageCode = {}));
var SupportedLanguage = /*@__PURE__*/(function (SupportedLanguage) {
    SupportedLanguage["Arabic"] = "ar";
    SupportedLanguage["Catalan"] = "ca";
    SupportedLanguage["Czech"] = "cs";
    SupportedLanguage["Danish"] = "da";
    SupportedLanguage["German"] = "de";
    SupportedLanguage["Greek"] = "el";
    SupportedLanguage["English"] = "en";
    SupportedLanguage["Spanish"] = "es";
    SupportedLanguage["Finnish"] = "fi";
    SupportedLanguage["French"] = "fr";
    SupportedLanguage["Hebrew"] = "he";
    SupportedLanguage["Croatian"] = "hr";
    SupportedLanguage["Hungarian"] = "hu";
    SupportedLanguage["Indonesian"] = "id";
    SupportedLanguage["Icelandic"] = "is";
    SupportedLanguage["Italian"] = "it";
    SupportedLanguage["Japanese"] = "ja";
    SupportedLanguage["Korean"] = "ko";
    SupportedLanguage["Lithuanian"] = "lt";
    SupportedLanguage["Dutch"] = "nl";
    SupportedLanguage["Norwegian"] = "no";
    SupportedLanguage["Polish"] = "pl";
    SupportedLanguage["Portuguese"] = "pt";
    SupportedLanguage["Romanian"] = "ro";
    SupportedLanguage["Russian"] = "ru";
    SupportedLanguage["Slovene"] = "sl";
    SupportedLanguage["Swedish"] = "sv";
    SupportedLanguage["Thai"] = "th";
    SupportedLanguage["Turkish"] = "tr";
    SupportedLanguage["Vietnamese"] = "vi";
    SupportedLanguage["Chinese"] = "zh";
    SupportedLanguage["ChineseTraditional"] = "zh_TW";
    return SupportedLanguage;
})(SupportedLanguage || (SupportedLanguage = {}));

var RuleKind = /*@__PURE__*/(function (RuleKind) {
    RuleKind["Targeting"] = "targeting";
    return RuleKind;
})(RuleKind || (RuleKind = {}));

const searchDefaultLeadDays = 7;
var ReplayMethod = /*@__PURE__*/(function (ReplayMethod) {
    /** @alias GET */
    ReplayMethod["Url"] = "URL";
    /** @alias POST */
    ReplayMethod["Dom"] = "DOM";
    ReplayMethod["Eval"] = "EVAL";
    return ReplayMethod;
})(ReplayMethod || (ReplayMethod = {}));

var DiscountSetting = /*@__PURE__*/(function (DiscountSetting) {
    DiscountSetting["DomDiscountInputDispatchEvents"] = "input_fire_event";
    DiscountSetting["DomDiscountSelectDispatchEvents"] = "select_fire_event";
    DiscountSetting["DomDiscountSelectSelector"] = "promocode_select_selector";
    DiscountSetting["DomDiscountSelectValue"] = "promocode_select_value";
    DiscountSetting["DomElementsRequireVisibility"] = "skip_form_invisible";
    DiscountSetting["DomSkip"] = "skip_POST";
    DiscountSetting["DomSubmitDelay"] = "send_form_delay";
    DiscountSetting["DomSubmitSelector"] = "form_button_selector";
    DiscountSetting["DomSubmitSkip"] = "skip_form_submit";
    DiscountSetting["UrlDiscountExtraParams"] = "promocode_extra_params";
    DiscountSetting["UrlSkip"] = "skip_GET";
    return DiscountSetting;
})(DiscountSetting || (DiscountSetting = {}));

var CountdownKind = /*@__PURE__*/(function (CountdownKind) {
    CountdownKind["FixedExpiration"] = "fixed-expiration";
    CountdownKind["DurationPerVisitor"] = "duration-per-visitor";
    return CountdownKind;
})(CountdownKind || (CountdownKind = {}));

var DayName = /*@__PURE__*/(function (DayName) {
    DayName["Sunday"] = "sunday";
    DayName["Monday"] = "monday";
    DayName["Tuesday"] = "tuesday";
    DayName["Wednesday"] = "wednesday";
    DayName["Thursday"] = "thursday";
    DayName["Friday"] = "friday";
    DayName["Saturday"] = "saturday";
    return DayName;
})(DayName || (DayName = {}));
var Day = /*@__PURE__*/(function (Day) {
    Day[Day["Sunday"] = 0] = "Sunday";
    Day[Day["Monday"] = 1] = "Monday";
    Day[Day["Tuesday"] = 2] = "Tuesday";
    Day[Day["Wednesday"] = 3] = "Wednesday";
    Day[Day["Thursday"] = 4] = "Thursday";
    Day[Day["Friday"] = 5] = "Friday";
    Day[Day["Saturday"] = 6] = "Saturday";
    return Day;
})(Day || (Day = {}));

var EvaluationFrequency = /*@__PURE__*/(function (EvaluationFrequency) {
    /**
       * Show the tool once per page view.
       */
    EvaluationFrequency["OncePerPage"] = "once-per-page";
    /**
       * Show the tool only once per session on a given Site.
       */
    EvaluationFrequency["OncePerSession"] = "once-per-session";
    /**
       * Show the tool only once per session across any Site.
       */
    EvaluationFrequency["OncePerSessionCrossSite"] = "once-per-session-cross-site";
    /**
       * Show the tool only once per visitor on a given Site.
       */
    EvaluationFrequency["OncePerVisitor"] = "once-per-visitor";
    /**
       * Show the tool only once per visitor on a cross any Site.
       */
    EvaluationFrequency["OncePerVisitorCrossSite"] = "once-per-visitor-cross-site";
    return EvaluationFrequency;
})(EvaluationFrequency || (EvaluationFrequency = {}));

var ReferenceTimezone = /*@__PURE__*/(function (ReferenceTimezone) {
    ReferenceTimezone["Site"] = "site";
    ReferenceTimezone["Visitor"] = "visitor";
    return ReferenceTimezone;
})(ReferenceTimezone || (ReferenceTimezone = {}));

var RetargetingPage = /*@__PURE__*/(function (RetargetingPage) {
    RetargetingPage[RetargetingPage["Any"] = 0] = "Any";
    RetargetingPage[RetargetingPage["Home"] = 1] = "Home";
    RetargetingPage[RetargetingPage["Calendar"] = 2] = "Calendar";
    RetargetingPage[RetargetingPage["RoomsAndRates"] = 3] = "RoomsAndRates";
    RetargetingPage[RetargetingPage["UserRegisterPage"] = 4] = "UserRegisterPage";
    RetargetingPage[RetargetingPage["BookingConfirmed"] = 5] = "BookingConfirmed";
    return RetargetingPage;
})(RetargetingPage || (RetargetingPage = {}));

var Scope = /*@__PURE__*/(function (Scope) {
    /** eq to old chain tools */
    Scope["CrossSite"] = "cross-site";
    /** eq to old property tools */
    Scope["Site"] = "site";
    return Scope;
})(Scope || (Scope = {}));

var SocialDomain = /*@__PURE__*/(function (SocialDomain) {
    SocialDomain["Facebook"] = "facebook";
    SocialDomain["Google"] = "google";
    SocialDomain["Instagram"] = "instagram";
    SocialDomain["Kayak"] = "kayak";
    SocialDomain["TripAdvisor"] = "tripadvisor";
    SocialDomain["Trivago"] = "trivago";
    SocialDomain["Twitter"] = "twitter";
    return SocialDomain;
})(SocialDomain || (SocialDomain = {}));

var PayloadPosition = /*@__PURE__*/(function (PayloadPosition) {
    PayloadPosition["Bottom"] = "B";
    PayloadPosition["LowerLeft"] = "LL";
    PayloadPosition["LowerMidLeft"] = "LML";
    PayloadPosition["LowerMidRight"] = "LMR";
    PayloadPosition["LowerRight"] = "LR";
    PayloadPosition["Top"] = "T";
    PayloadPosition["UpperLeft"] = "UL";
    PayloadPosition["UpperMidLeft"] = "UML";
    PayloadPosition["UpperRight"] = "UR";
    return PayloadPosition;
})(PayloadPosition || (PayloadPosition = {}));
var PayloadLayoutType = /*@__PURE__*/(function (PayloadLayoutType) {
    PayloadLayoutType["Circular"] = "circular";
    PayloadLayoutType["CustomImage"] = "custom-image";
    PayloadLayoutType["Fullscreen"] = "fullscreen";
    PayloadLayoutType["FullscreenMini"] = "fullscreen-mini";
    PayloadLayoutType["LowerNotification"] = "lower-notification";
    PayloadLayoutType["NotificationTab"] = "notification-tab";
    PayloadLayoutType["Sidebar"] = "sidebar";
    PayloadLayoutType["SideGradient"] = "side-gradient";
    PayloadLayoutType["Sticky"] = "sticky";
    PayloadLayoutType["SquareImage"] = "square-image";
    PayloadLayoutType["SquarePopup"] = "square-popup";
    return PayloadLayoutType;
})(PayloadLayoutType || (PayloadLayoutType = {}));
var NostromoPage = /*@__PURE__*/(function (NostromoPage) {
    NostromoPage["Home"] = "home";
    NostromoPage["Calendar"] = "calendar";
    NostromoPage["RoomsAndRates"] = "room";
    NostromoPage["UserRegisterPage"] = "register";
    NostromoPage["BookingConfirmed"] = "confirmed";
    return NostromoPage;
})(NostromoPage || (NostromoPage = {}));
var NostromoAvailabilityType = /*@__PURE__*/(function (NostromoAvailabilityType) {
    NostromoAvailabilityType["Custom"] = "custom";
    NostromoAvailabilityType["SoldOut"] = "soldOut";
    NostromoAvailabilityType["NotSoldOut"] = "notSoldOut";
    return NostromoAvailabilityType;
})(NostromoAvailabilityType || (NostromoAvailabilityType = {}));

var TargetingRuleAbstractVariableRelationalOperation = /*@__PURE__*/(function (TargetingRuleAbstractVariableRelationalOperation) {
    TargetingRuleAbstractVariableRelationalOperation["ValueIsNotEqual"] = "not-equal";
    TargetingRuleAbstractVariableRelationalOperation["ValueIsEqual"] = "equal";
    TargetingRuleAbstractVariableRelationalOperation["ValueIsNotEmpty"] = "not-empty";
    TargetingRuleAbstractVariableRelationalOperation["ValueIsEmpty"] = "empty";
    TargetingRuleAbstractVariableRelationalOperation["ValueIsLowerThan"] = "lower-than";
    TargetingRuleAbstractVariableRelationalOperation["ValueIsGreaterThan"] = "greater-than";
    TargetingRuleAbstractVariableRelationalOperation["ValueDoesContain"] = "contain";
    TargetingRuleAbstractVariableRelationalOperation["ValueDoesNotContain"] = "not-contain";
    return TargetingRuleAbstractVariableRelationalOperation;
})(TargetingRuleAbstractVariableRelationalOperation || (TargetingRuleAbstractVariableRelationalOperation = {}));
var TargetingRuleCondition = /*@__PURE__*/(function (TargetingRuleCondition) {
    TargetingRuleCondition["ShouldInclude"] = "include";
    TargetingRuleCondition["ShouldExclude"] = "exclude";
    return TargetingRuleCondition;
})(TargetingRuleCondition || (TargetingRuleCondition = {}));
var TargetingRuleRelationalOperation = /*@__PURE__*/(function (TargetingRuleRelationalOperation) {
    TargetingRuleRelationalOperation["Between"] = "between";
    TargetingRuleRelationalOperation["Contain"] = "contain";
    TargetingRuleRelationalOperation["Equal"] = "equal";
    TargetingRuleRelationalOperation["GreaterThan"] = "greater-than";
    TargetingRuleRelationalOperation["LessThan"] = "less-than";
    return TargetingRuleRelationalOperation;
})(TargetingRuleRelationalOperation || (TargetingRuleRelationalOperation = {}));
var TargetingRuleOraculoVariableKind = /*@__PURE__*/(function (TargetingRuleOraculoVariableKind) {
    TargetingRuleOraculoVariableKind["DateFlexibility"] = "date_flexibility";
    TargetingRuleOraculoVariableKind["DestinationFlexibility"] = "destination_flexibility";
    TargetingRuleOraculoVariableKind["Intent"] = "intent";
    TargetingRuleOraculoVariableKind["Spend"] = "spend";
    return TargetingRuleOraculoVariableKind;
})(TargetingRuleOraculoVariableKind || (TargetingRuleOraculoVariableKind = {}));
var TargetingRulesProp = /*@__PURE__*/(function (TargetingRulesProp) {
    TargetingRulesProp["DatalayerVariables"] = "datalayerVariables";
    TargetingRulesProp["StayAvailability"] = "stayAvailability";
    TargetingRulesProp["StayDates"] = "stayDates";
    TargetingRulesProp["StayDays"] = "stayDays";
    TargetingRulesProp["StayDaysUntilCheckIn"] = "stayDaysUntilCheckIn";
    TargetingRulesProp["StayDisparities"] = "stayDisparities";
    TargetingRulesProp["StayLength"] = "stayLength";
    TargetingRulesProp["StayOccupancyAdults"] = "stayOccupancyAdults";
    TargetingRulesProp["StayOccupancyChildren"] = "stayOccupancyChildren";
    TargetingRulesProp["StayOccupancyRooms"] = "stayOccupancyRooms";
    TargetingRulesProp["StayTotalCost"] = "stayTotalCost";
    TargetingRulesProp["TrafficSource"] = "trafficSource";
    TargetingRulesProp["UrlVariables"] = "urlVariables";
    TargetingRulesProp["VisitDates"] = "visitDates";
    TargetingRulesProp["VisitDays"] = "visitDays";
    TargetingRulesProp["VisitHours"] = "visitHours";
    TargetingRulesProp["VisitorDaysSincePreviousVisit"] = "visitorDaysSincePreviousVisit";
    TargetingRulesProp["VisitorFunnelProgress"] = "visitorFunnelProgress";
    TargetingRulesProp["VisitorGeolocation"] = "visitorGeolocation";
    TargetingRulesProp["VisitorOraculoScore"] = "visitorOraculoScore";
    TargetingRulesProp["VisitorPreviousVisitsCount"] = "visitorPreviousVisitsCount";
    TargetingRulesProp["VisitorStatus"] = "visitorStatus";
    return TargetingRulesProp;
})(TargetingRulesProp || (TargetingRulesProp = {}));

var TriggerKind = /*@__PURE__*/(function (TriggerKind) {
    TriggerKind["Idle"] = "on-idle";
    TriggerKind["Load"] = "on-load";
    TriggerKind["Scroll"] = "on-scroll";
    return TriggerKind;
})(TriggerKind || (TriggerKind = {}));

var UriSchema = /*@__PURE__*/(function (UriSchema) {
    UriSchema["Http"] = "http";
    UriSchema["Mailto"] = "mailto";
    UriSchema["Tel"] = "tel";
    return UriSchema;
})(UriSchema || (UriSchema = {}));

var GenerateCallbackQueueEdge = /*@__PURE__*/(function (GenerateCallbackQueueEdge) {
    GenerateCallbackQueueEdge["Leading"] = "leading";
    GenerateCallbackQueueEdge["Trailing"] = "trailing";
    return GenerateCallbackQueueEdge;
})(GenerateCallbackQueueEdge || (GenerateCallbackQueueEdge = {}));

var ActivityKind = /*@__PURE__*/(function (ActivityKind) {
    ActivityKind["Engage"] = "click";
    ActivityKind["Dismiss"] = "close";
    return ActivityKind;
})(ActivityKind || (ActivityKind = {}));

var WidgetTypeId = /*@__PURE__*/(function (WidgetTypeId) {
    WidgetTypeId["Exit"] = "31";
    WidgetTypeId["Inliner"] = "33";
    WidgetTypeId["Layer"] = "32";
    WidgetTypeId["Note"] = "2";
    return WidgetTypeId;
})(WidgetTypeId || (WidgetTypeId = {}));
var PageName = /*@__PURE__*/(function (PageName) {
    PageName["BookingConfirmed"] = "Booking Confirmed";
    PageName["BookingIframe"] = "Booking Iframe";
    PageName["Calendar"] = "Calendar";
    PageName["Homepage"] = "Index";
    PageName["Packages"] = "Packages";
    PageName["RoomsAndRates"] = "Rooms and Rates";
    PageName["UserRegisterPage"] = "User Register Page";
    return PageName;
})(PageName || (PageName = {}));
var WidgetsList = /*@__PURE__*/(function (WidgetsList) {
    WidgetsList["Booking"] = "booking";
    WidgetsList["Chat"] = "chat";
    WidgetsList["Inliner"] = "inliner";
    WidgetsList["LastSearch"] = "lastSearch";
    WidgetsList["Note"] = "note";
    WidgetsList["Pack"] = "pack";
    WidgetsList["Price"] = "price";
    WidgetsList["PriceMatch"] = "pricematch";
    WidgetsList["Review"] = "review";
    WidgetsList["Snippet"] = "snippet";
    WidgetsList["Layer"] = "layer";
    // Note: order is important. By pushing the Exit Widget to the end,
    // we increase the chance its view is created later.
    // When its z-index value draws with other widgets, then Exit would display on top.
    WidgetsList["Exit"] = "exit";
    return WidgetsList;
})(WidgetsList || (WidgetsList = {}));

var PriceNightConfig = /*@__PURE__*/(function (PriceNightConfig) {
    PriceNightConfig[PriceNightConfig["PerStay"] = 0] = "PerStay";
    PriceNightConfig[PriceNightConfig["PerNight"] = 1] = "PerNight";
    PriceNightConfig[PriceNightConfig["PerPerson"] = 2] = "PerPerson";
    PriceNightConfig[PriceNightConfig["PerAdult"] = 3] = "PerAdult";
    return PriceNightConfig;
})(PriceNightConfig || (PriceNightConfig = {}));
var SearchPriceSpecial = /*@__PURE__*/(function (SearchPriceSpecial) {
    /**
     * The cheapest normal available price (usually would be the BAR).
     */
    SearchPriceSpecial["None"] = "0";
    /**
     * Any other thing that it is not the cheapest "normal" available price.
     * Id est, anthing that is sensitive to produces a _not real_ disparity.
     */
    SearchPriceSpecial["Generic"] = "1";
    /**
     * The price is special because it is influenced by discount.
     */
    SearchPriceSpecial["Discount"] = "2";
    return SearchPriceSpecial;
})(SearchPriceSpecial || (SearchPriceSpecial = {}));
var SearchPriceType = /*@__PURE__*/(function (SearchPriceType) {
    /**
     * The price amount does not include taxes.
     */
    SearchPriceType["WithoutTaxes"] = "base";
    /**
     * The price amount does include taxes.
     */
    SearchPriceType["WithTaxes"] = "full";
    return SearchPriceType;
})(SearchPriceType || (SearchPriceType = {}));
var RoomKind = /*@__PURE__*/(function (RoomKind) {
    RoomKind["Standard"] = "standard";
    RoomKind["Superior"] = "superior";
    RoomKind["Suite"] = "suite";
    return RoomKind;
})(RoomKind || (RoomKind = {}));

var SaveSearchUrlOption = /*@__PURE__*/(function (SaveSearchUrlOption) {
    SaveSearchUrlOption[SaveSearchUrlOption["BookingEngine"] = 0] = "BookingEngine";
    SaveSearchUrlOption[SaveSearchUrlOption["HotelHomepage"] = 1] = "HotelHomepage";
    SaveSearchUrlOption[SaveSearchUrlOption["CustomUrl"] = 2] = "CustomUrl";
    SaveSearchUrlOption[SaveSearchUrlOption["JavaScriptVariable"] = 3] = "JavaScriptVariable";
    return SaveSearchUrlOption;
})(SaveSearchUrlOption || (SaveSearchUrlOption = {}));

export { ActivityKind, CURRENT_SCRIPT_ATTR, CURRENT_SCRIPT_VAR, CountdownKind, CurrencyCode, DEFAULT_PROPERTY_DESCRIPTOR, Day, DayName, Device, DiscountCodeAmountKind, DiscountCodeKind, DiscountSetting, EvaluationFrequency, FontType as FontKind, GenerateCallbackQueueEdge, LanguageCode, MEDIA, NostromoAvailabilityType, NostromoPage, PageName, PayloadLayoutType, PayloadPosition, PriceNightConfig, ReferenceTimezone, ReplayMethod, RetargetingPage, RightToLeftLanguageCode, RoomKind, RuleKind, SaveSearchUrlOption, Scope, SearchPriceSpecial, SearchPriceType, SocialDomain, SupportedLanguage, THN_DATE_FORMAT, TargetingRuleAbstractVariableRelationalOperation, TargetingRuleCondition, TargetingRuleOraculoVariableKind, TargetingRuleRelationalOperation, TargetingRulesProp, ToolActionKind, TriggerKind, UriSchema, WidgetTypeId, WidgetsList, searchDefaultLeadDays };
